const SiteFooter = () => {
  return (
    <>
      <section className="closer" id="get">
        <div className="wrap">
          <h2>Start streaming</h2>
          <p>
            We're in public beta right now. We'd love your help getting this
            thing tested.
          </p>
          <a className="btn btn--lg" href="/beta">
            Download now
          </a>
        </div>
      </section>

      <footer className="footer">
        <div className="wrap footer__inner">
          <span>StreamLover · Now broadcasting</span>
          <span className="footer__dots" aria-hidden="true">
            <i style={{ background: "var(--coral)" }} />
            <i style={{ background: "var(--aqua)" }} />
            <i style={{ background: "var(--sun)" }} />
            <i style={{ background: "var(--grape)" }} />
          </span>
          <span>Made for people who love radio</span>
        </div>
        <div className="wrap footer__legal">
          © 2026 Splatboard LLC · <a href="/terms">Terms</a> ·{" "}
          <a href="/privacy">Privacy</a> · <a href="/dmca">DMCA</a> ·{" "}
          <a href="/delete-account">Delete account</a>
        </div>
      </footer>
    </>
  );
};

export default SiteFooter;
